var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-chart"},[_c('span',{staticClass:"icon-empty-set empty-chart__icon"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('OrganizationReport.empty_dashboard'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }